import { useQuery } from "@tanstack/react-query";
import {
  AgentIdAndName,
  usePermissionsService,
} from "../services/api/permissions-service";

export function useMemberPermissions(userIds: string[] | undefined) {
  const { getMemberPermissions } = usePermissionsService();

  return useQuery({
    queryKey: ["member-permissions", userIds],
    queryFn: async () => {
      if (!userIds?.length) return {};

      const permissionsMap: Record<string, string[]> = {};
      const permissionsPromises = userIds.map(async (userId) => {
        try {
          const permissionedAgents = await getMemberPermissions(userId);
          return {
            userId,
            permissions: permissionedAgents.map(
              (agent: AgentIdAndName) => agent.id
            ),
          };
        } catch (error) {
          console.error(
            `Error fetching permissions for user ${userId}:`,
            error
          );
          return { userId, permissions: [] };
        }
      });
      const results = await Promise.all(permissionsPromises);
      results.forEach(({ userId, permissions }) => {
        permissionsMap[userId] = permissions;
      });
      return permissionsMap;
    },
    retry: false,
    enabled: !!userIds?.length,
  });
}
